import Reveal from "@/components/base/Reveal";

export default function DownloadBanner() {
  return (
    <section className="bg-background-50">
      <div className="mx-auto max-w-[1400px] px-4 py-10 md:px-8 md:py-14">
        <Reveal>
          <div className="overflow-hidden rounded-lg bg-primary-500">
            <div className="flex flex-col items-start justify-between gap-6 px-6 py-8 md:flex-row md:items-center md:px-10 md:py-10">
              <div className="max-w-xl">
                <span className="inline-flex items-center gap-2 rounded-full bg-primary-600 px-3 py-1 text-[11px] text-background-50">
                  <i className="ri-smartphone-line" />
                  客户端同步上线
                </span>
                <h2 className="mt-4 font-heading text-2xl font-bold leading-snug text-background-50 md:text-3xl">
                  下载「网曝黑料」客户端
                </h2>
                <p className="mt-3 text-sm leading-relaxed text-primary-50">
                  新进展第一时间推送、离线追踪专题、按事件订阅提醒，让每一条后续瓜都不会从指缝溜走。
                </p>
              </div>
              <div className="flex w-full flex-col gap-3 sm:w-auto sm:flex-row">
                <a
                  href="#top"
                  className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-5 py-3 text-sm font-medium text-primary-700 transition-colors hover:bg-primary-50"
                >
                  <i className="ri-apple-fill text-lg" />
                  前往 App Store
                </a>
                <a
                  href="#top"
                  className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-primary-200 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
                >
                  <i className="ri-android-fill text-lg" />
                  获取安卓版本
                </a>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}